import {
  GET_PLC_SAFETY_ZONE_DEPENDENCIES,
  GET_PLC_SAFETY_ZONE_DEPENDENCIES_SUCCESS,
  GET_PLC_SAFETY_ZONE_DEPENDENCIES_ERROR,
} from './actionTypes';

export const getPlcSafetyZoneDependencies = (user) => ({
  type: GET_PLC_SAFETY_ZONE_DEPENDENCIES,
  payload: { user },
});

export const getPlcSafetyZoneDependenciesSuccess = (zoneDependencies) => ({
  type: GET_PLC_SAFETY_ZONE_DEPENDENCIES_SUCCESS,
  payload: { zoneDependencies },
});

export const getPlcSafetyZoneDependenciesError = (error) => ({
  type: GET_PLC_SAFETY_ZONE_DEPENDENCIES_ERROR,
  payload: error,
});
